<div
  class="ui-g map-container"
  [ngStyle]="customStyle"
  [ngClass]="styleClass"
  style="border: 1px solid lightgray"
>
  <div class="ui-g-12" style="height: 100%">
    <div class="ui-g-12" style="height: 100%">
      <agm-map
        [latitude]="latitude"
        [longitude]="longitude"
        [scrollwheel]="true"
        [(zoom)]="zoom"
        (mapClick)="onMapClicked($event)"
      >
        <agm-marker
          *ngIf="origin != null && origin != undefined"
          [latitude]="origin.latitude"
          [longitude]="origin.longitude"
          [markerDraggable]="readOnlyMode != 1 && readOnlyMode != 2"
          (dragEnd)="originMarkerDragEnd($event)"
          [iconUrl]="originIcon"
        >
        </agm-marker>

        <agm-marker
          *ngIf="destination != null && destination != undefined"
          [latitude]="destination.latitude"
          [longitude]="destination.longitude"
          [markerDraggable]="readOnlyMode != 1 && readOnlyMode != 3"
          (dragEnd)="destinationMarkerDragEnd($event)"
          [iconUrl]="destinationIcon"
        >
        </agm-marker>

        <!--        <agm-marker-->
        <!--          *ngFor="let markerPoint of markerPoints"-->
        <!--          [latitude]="markerPoint.latitude"-->
        <!--          [longitude]="markerPoint.longitude"-->
        <!--          [markerDraggable]="false"-->
        <!--          [label]="markerPoint.label"-->
        <!--        >-->
        <!--        </agm-marker>-->

        <agm-marker
          *ngFor="let task of tasks"
          [latitude]="task.currentLocation ? task.currentLocation.latitude : null"
          [longitude]="task.currentLocation ? task.currentLocation.longitude : null"
          [markerDraggable]="false"
          (markerClick)="taskClick(task)"
          [iconUrl]="taskTrackingIcon"
        >
        </agm-marker>

        <agm-marker
          *ngFor="let task of tasks; let i = index"
          [latitude]="task.pickupLocation.latitude"
          [longitude]="task.pickupLocation.longitude"
          [visible]="!task.map?.hidden"
          [markerDraggable]="readOnlyMode != 1"
          (dragEnd)="originMarkerDragEnd($event)"
          [iconUrl]="getOriginIcon(tasks, task)"
          (markerClick)="taskClick(task)"
        >
        </agm-marker>

        <agm-marker
          *ngFor="let task of tasks; let i = index"
          [latitude]="task.dropoffLocation.latitude"
          [longitude]="task.dropoffLocation.longitude"
          [markerDraggable]="readOnlyMode != 1"
          [visible]="!task.map?.hidden"
          (dragEnd)="destinationMarkerDragEnd($event)"
          [iconUrl]="getDestinationIcon(tasks, task)"
          (markerClick)="taskClick(task)"
        >
        </agm-marker>

        <agm-map-directions
          *ngFor="let task of visibleTasksNoPolyline(tasks)"
          [(origin)]="task.pickupLocation"
          [(destination)]="task.dropoffLocation"
          [directions]="task.directions"
          [earliestPickup]="earliestPickup"
          [color]="task.map?.directions?.color"
          [opacity]="task.map?.directions?.opacity"
        ></agm-map-directions>

        <agm-map-task-polyline
          *ngFor="let task of visibleTasksWithPolyline(tasks)"
          [polyline]="task.polyline"
          [color]="task.map?.directions?.color"
          [opacity]="task.map?.directions?.opacity"
        ></agm-map-task-polyline>

        <agm-marker
          *ngIf="liveTask && liveTask.currentLocation"
          [latitude]="liveTask.currentLocation.latitude"
          [longitude]="liveTask.currentLocation.longitude"
          [markerDraggable]="false"
          [iconUrl]="
            liveTask.lastStepName == headingToPickupLocation ? personIcon : taskTrackingIcon
          "
        >
        </agm-marker>

        <agm-polyline
          *ngIf="liveTask && liveTask.currentLocation && showHeadingTrack"
          [strokeColor]="'blue'"
        >
          <agm-polyline-point
            *ngFor="let track of filterVehicleTrack(liveTask.taskTracking, true)"
            [latitude]="track.latitude"
            [longitude]="track.longitude"
          ></agm-polyline-point>
        </agm-polyline>

        <agm-polyline *ngIf="liveTask && liveTask.currentLocation">
          <agm-polyline-point
            *ngFor="let track of filterVehicleTrack(liveTask.taskTracking, false)"
            [latitude]="track.latitude"
            [longitude]="track.longitude"
          ></agm-polyline-point>
        </agm-polyline>

        <agm-marker
          *ngFor="let org of organisations"
          [latitude]="org.latitude"
          [iconUrl]="organisationIcon"
          [longitude]="org.longitude"
          [markerDraggable]="false"
          [title]="org.name"
        >
        </agm-marker>

        <agm-circle
          *ngFor="let radiusPoint of radiusPoints"
          [latitude]="radiusPoint.latitude"
          [longitude]="radiusPoint.longitude"
          [radius]="radiusPoint.radius"
          [fillColor]="radiusPoint.color ? radiusPoint.color : 'red'"
          [circleDraggable]="false"
          [editable]="false"
        >
        </agm-circle>

        <agm-map-directions
          [(origin)]="origin"
          [(destination)]="destination"
          [earliestPickup]="earliestPickup"
        ></agm-map-directions>

        <agm-overlay
          *ngFor="let overlay of overlays"
          [latitude]="overlay.location?.latitude"
          [longitude]="overlay.location?.longitude"
        >
          <div (click)="haveClicked({ event: $event, overlay: overlay })">
            <img
              [src]="overlay.icon?.url"
              [height]="overlay.icon?.height"
              [width]="overlay.icon?.width"
              [style]="overlay.icon?.style"
            />
          </div>
        </agm-overlay>

        <agm-map-context-menu *ngIf="readOnlyMode != 1 && readOnlyMode != 4">
          <div #contextMenuContent style="width: 160px">
            <div class="ui-g">
              <div class="ui-g-12">
                <div
                  class="ui-g-12"
                  style="margin-bottom: 2px; padding: 0"
                  *ngIf="readOnlyMode != 2"
                >
                  <button
                    pButton
                    type="button"
                    (click)="SetStart()"
                    label="Set Start"
                    style="width: 100%"
                  ></button>
                </div>
                <div
                  class="ui-g-12"
                  style="margin-bottom: 2px; padding: 0"
                  *ngIf="readOnlyMode != 3"
                >
                  <button
                    pButton
                    type="button"
                    (click)="SetEnd()"
                    label="Set End"
                    style="width: 100%"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </agm-map-context-menu>

        <!--Planned Tasks for Driver Plan-->

        <agm-marker
          *ngFor="let task of plannedTasks"
          [latitude]="task.pickupLocation.latitude"
          [longitude]="task.pickupLocation.longitude"
          [iconUrl]="originIcon"
        >
        </agm-marker>

        <agm-marker
          *ngFor="let task of plannedTasks"
          [latitude]="task.dropoffLocation.latitude"
          [longitude]="task.dropoffLocation.longitude"
          [iconUrl]="destinationIcon"
        >
        </agm-marker>

        <!-- Suggested Tasks (EC Matching) -->
        <agm-marker
          *ngFor="let task of suggestedTasks"
          [latitude]="task.pickupLocation.latitude"
          [longitude]="task.pickupLocation.longitude"
          [iconUrl]="BIcon"
        >
        </agm-marker>

        <agm-marker
          *ngFor="let task of suggestedTasks"
          [latitude]="task.dropoffLocation.latitude"
          [longitude]="task.dropoffLocation.longitude"
          [iconUrl]="CIcon"
        >
        </agm-marker>

        <agm-map-directions
          *ngFor="let task of suggestedTasks"
          [(origin)]="task.pickupLocation"
          [(destination)]="task.dropoffLocation"
          [directions]="task.directions"
          [earliestPickup]="earliestPickup"
          color="grey"
          opacity="0.8"
        ></agm-map-directions>

        <!--Suppliers with cards-->
        <agm-marker
          *ngFor="let item of suppliers"
          [latitude]="item.latitude"
          (markerClick)="clickedMarker(supplierWindow)"
          [longitude]="item.longitude"
          [markerDraggable]="false"
          [title]="item.name"
          [iconUrl]="getIconURL(item)"
        >
          <agm-info-window #supplierWindow>
            <supplier-card [data]="item" (driverPlanClick)="driverPlan($event)"></supplier-card>
          </agm-info-window>
        </agm-marker>

        <agm-marker
          *ngFor="let pause of pauses"
          [latitude]="pause.latitude"
          [longitude]="pause.longitude"
          [iconUrl]="pauseIcon"
        >
          <agm-info-window #supplierWindow>
            <div>
              <span
                ><b>{{ pause.name }}</b
                >: {{ pause.createdOn | datex : 'ddd DD MMM YY HH:mm' }} </span
              ><br />
              <span *ngIf="pause.resumeInfo"
                ><b>{{ pause.resumeInfo.name }}</b
                >: {{ pause.resumeInfo.createdOn | datex : 'ddd DD MMM YY HH:mm' }} ({{
                  pause.resumeInfo.elapsed
                }})</span
              >
            </div>
          </agm-info-window>
        </agm-marker>
      </agm-map>
    </div>
  </div>
</div>
